import { createFileRoute, Outlet } from "@tanstack/react-router";

import { BillingProductFeatureGate } from "src/components/BillingProductFeatureGate";
import { ContentHubLayout } from "src/pages/ContentHubLayout";

export const Route = createFileRoute("/_auth/_coach/content-hub")({
  component: RouteComponent,
  staticData: {
    getBreadcrumb: () => {
      return {
        href: "/content-hub",
        labelTranslationKey: "contentHub.title" as const,
      };
    },
  },
});

function RouteComponent() {
  return (
    <BillingProductFeatureGate feature="contentHub">
      <ContentHubLayout>
        <Outlet />
      </ContentHubLayout>
    </BillingProductFeatureGate>
  );
}
